import React, { useRef, useState } from 'react';
import Container from '../common/container';
import Button from '../common/button';
import { NextLink, Translate, useTranslate } from '~/i18n';
import cn from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';

const Hero = () => {
   const slides = [
      {
         title: <Translate id="common:hero slide 1 title" />,
         subtitle: <Translate id="common:hero slide 1 subtitle" />,
         image: '/madinah/home/hero-01.jpeg',
         link: '/madinah/destinations',
      },
      {
         title: <Translate id="common:hero slide 2 title" />,
         subtitle: <Translate id="common:hero slide 2 subtitle" />,
         image: '/madinah/home/hero-02.jpg',
         link: '/madinah/destinations',
      },
      {
         title: <Translate id="common:hero slide 3 title" />,
         subtitle: <Translate id="common:hero slide 3 subtitle" />,
         image: '/madinah/home/hero-03.jpg',
         link: '/madinah/destinations',
      },
      {
         title: <Translate id="common:hero slide 4 title" />,
         subtitle: <Translate id="common:hero slide 4 subtitle" />,
         image: '/madinah/home/hero-04.png',
         link: '/madinah/destinations',
      },
   ];
   const { dir } = useTranslate();

   const [activeIndex, setActiveIndex] = useState(0);
   const swiperRef = useRef<{ swiper: any }>({ swiper: null }); // Reference to the Swiper instance

   const handleSlideChange = (swiper: { activeIndex: React.SetStateAction<number> }) => {
      setActiveIndex(swiper.activeIndex);
   };
   const handleSlidesChange = (index: number) => {
      setActiveIndex(index);
      if (swiperRef.current && swiperRef.current.swiper) {
         swiperRef.current.swiper.slideTo(index);
      }
   };
   return (
      <div className="overflow-y-hidden ">
         <Swiper
            key={`${dir}-hero`}
            ref={swiperRef} // Attach ref to Swiper instance
            dir={dir}
            effect="fade"
            slidesPerView={1}
            modules={[Navigation, Autoplay, EffectFade]}
            autoplay={{ delay: 5000, disableOnInteraction: false }} // Set autoplay delay and allow interaction
            onSlideChange={handleSlideChange} // Track slide change
         >
            {slides.map((slide, index) => (
               <SwiperSlide key={index}>
                  <div
                     className="relative h-screen bg-center bg-no-repeat bg-cover before:bg-black before:absolute before:inset-0 before:bg-opacity-20 before:z-[1]"
                     style={{ backgroundImage: `url(${slide.image})` }}>
                     <Container className="h-full py-24">
                        <div className="relative z-10 flex flex-col justify-between w-full h-full gap-8">
                           <div>
                              <SocialMedia />
                           </div>
                           <div className="w-full text-white lg:w-2/3">
                              <div className="mb-2 text-4xl md:text-5xl">{slide.title}</div>

                              {/* <div className="text-5xl ">{slide.subtitle}</div> */}

                              <div className="flex items-center gap-2 mt-8">
                                 <Button type="primary">
                                    <NextLink href={slide.link}>
                                       <Translate id="common:explore destinations" />
                                    </NextLink>
                                 </Button>
                              </div>
                           </div>
                        </div>
                     </Container>
                  </div>
               </SwiperSlide>
            ))}

            {/* Navigation Bars */}
            <div className="flex justify-center mt-4 gap-x-2">
               {slides.map((_, index) => (
                  <div
                     key={index}
                     onClick={() => handleSlidesChange(index)} // Navigate to clicked slide
                     className={cn(
                        `relative z-10 w-[10dvw] md:w-20 -mt-[8vh] h-1 transition-all  hover:bg-madinah-primary hover:transition-all cursor-pointer`,
                        activeIndex === index ? 'bg-madinah-primary' : 'bg-white/50'
                     )}></div>
               ))}
            </div>
         </Swiper>
      </div>
   );
};

const SocialMedia = () => {
   const links = [
      {
         name: 'Instagram',
         iconSrc: '/madinah/home/instagram.svg',
         href: 'https://www.instagram.com/visitmadinahsa',
      },
      { name: 'X', iconSrc: '/madinah/home/x.svg', href: 'https://www.x.com/visitmadinahsa' },
      {
         name: 'Youtube',
         iconSrc: '/madinah/home/youtube.svg',
         href: 'https://www.youtube.com/@visitmadinahsa',
      },
      {
         name: 'Facebook',
         iconSrc: '/madinah/home/facebook.svg',
         href: 'https://www.facebook.com/Visitmadinahsa',
      },
      {
         name: 'Snapchat',
         iconSrc: '/madinah/home/snapchat.svg',
         href: 'https://www.snapchat.com/add/visitmadinahsa',
      },
      {
         name: 'Tiktok',
         iconSrc: '/madinah/home/tiktok.svg',
         href: 'https://www.tiktok.com/@visitmadinahsa',
      },
   ];
   return (
      <div className="flex items-center gap-2 md:gap-3">
         {links.map((link, idx) => (
            <a
               key={idx}
               href={link.href}
               target="_blank"
               rel="noopener noreferrer"
               className="flex items-center justify-center w-8 h-8 text-white transition-all border rounded-full border-white/25 bg-white/15 hover:bg-madinah-primary">
               <img src={link.iconSrc} alt={link.name} />
            </a>
         ))}
      </div>
   );
};

export default Hero;
